<template>
	<div style="background-color:#FFF">
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-100 text-center" style="display: flex; justify-content: space-between; align-items: center; flex-direction: row; margin-bottom: 40px">
				<div>
					<h3 class="order-title">បង្កាន់ដៃទទួលប្រាក់</h3>
				</div>
				<qr-code :text="$route.params.hash" :size="300" style="width: 100px;"></qr-code>
			</div>

			<div class="md-layout-item md-small-size-50 md-size-50">
				<table style="width: 100%; border-collapse: collapse">
					<tr>
						<td class="print-logn-td">លេខកូដរំលោះ</td>
						<td class="print-logn-td" style="width: 20px">:</td>
						<td class="print-logn-td"><b><span v-if="String(loan.hash).length > 0">{{loan.hash}}</span><span v-else>N/A</span></b></td>
					</tr>
					<tr>
						<td class="print-logn-td">លេខឡូតិ៍</td>
						<td class="print-logn-td">:</td>
						<td class="print-logn-td"><b><span v-if="String(loan.lot).length > 0">{{loan.lot}} ({{loan.project_name}})</span><span v-else>N/A</span></b></td>
					</tr>
					<tr>
						<td class="print-logn-td">ថ្ងៃបង់ប្រាក់</td>
						<td class="print-logn-td">:</td>
						<td class="print-logn-td"><b><span v-if="String(payment_receipt.paid_date).length > 0">{{config.datelify(payment_receipt.paid_date)}}</span><span v-else>N/A</span></b></td>
					</tr>
				</table>
			</div>
			<div class="md-layout-item md-small-size-50 md-size-50">
				<table style="width: 100%; border-collapse: collapse">
					<tr>
						<td class="print-logn-td">លេខកូដអតិថិជន</td>
						<td class="print-logn-td" style="width: 20px">:</td>
						<td class="print-logn-td"><b><span v-if="String(loan.client_hash).length > 0">{{loan.client_hash}}</span><span v-else>N/A</span></b></td>
					</tr>
					<tr>
						<td class="print-logn-td">ឈ្មោះអតិថិជន</td>
						<td class="print-logn-td">:</td>
						<td class="print-logn-td"><b><span v-if="String(loan.client_name).length > 0">{{loan.client_name}}</span><span v-else>N/A</span></b></td>
					</tr>
					<tr>
						<td class="print-logn-td">លេខទូរស័ព្ទ</td>
						<td class="print-logn-td">:</td>
						<td class="print-logn-td"><b><span v-if="String(loan.client_phone).length > 0">{{loan.client_phone}}</span><span v-else>N/A</span></b></td>
					</tr>
				</table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<table style="border-collapse: collapse; width: 100%;border:1px solid black; font-weight: 9px !important;margin-top: 40px">
					<thead>
						<tr style="border: 1px solid black;padding: 5px">
							<td class="print-row print-row-bold">លេខកូដ<br>ទូទាត់ប្រាក់</td>
							<td class="print-row print-row-bold">កាលបរិច្ឆេទ<br>ត្រូវបង់ប្រាក់</td>
							<td class="print-row print-row-bold">ប្រាក់ដើម<br>ត្រូវបង់</td>
							<td class="print-row print-row-bold">ការប្រាក់<br>ត្រូវបង់</td>
							<td class="print-row print-row-bold">ប្រាក់ពិន័យ<br>ត្រូវបង់</td>
							<td class="print-row print-row-bold">ទឹកប្រាក់<br>បានបង់សរុប</td>
							<td class="print-row print-row-bold">ប្រាក់ដើម<br>នៅសល់</td>
						</tr>
					</thead>
					<tbody>
						<tr style="border: 1px solid black">
							<td class="print-row"><b>{{ payment_receipt.hash }}</b></td>
							<td class="print-row"><b>{{config.datelifyShort(payment_receipt.due_date) }}</b></td>
							<td class="print-row"><b>{{config.moneylify(payment_receipt.principal) }}</b></td>
							<td class="print-row"><b>{{config.moneylify(payment_receipt.interest) }}</b></td>
							<td class="print-row"><b>{{config.moneylify(payment_receipt.fine) }}</b></td>
							<td class="print-row"><b>{{config.moneylify(payment_receipt.interest + payment_receipt.principal)}}</b></td>
							<td class="print-row" style="border: 1px solid black;padding: 5px;text-align: center;"><b>{{config.moneylify(payment_receipt.balance) }}</b></td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<table style="width: 100%; margin-top: 50px">
						<thead>
							<tr class="no-hover">
								<td style="text-align: center; font-weight: bold;">ហត្ថលេខា និងឈ្មោះអ្នកប្រគល់</td>
								<td style="text-align: center; font-weight: bold;display:flex; justify-content: center;align-items: center;">ហត្ថលេខា និងឈ្មោះអ្នកទទួល</td>
							</tr>
							<tr class="no-hover">
								<td style="text-align: center;height: 100px; font-weight: bold;"></td>
								<td style="text-align: center;height: 100px; font-weight: bold;"></td>
							</tr>
						</thead>
					</table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">

			</div>
		</div>
	</div>
</template>

<script>
	import VueQRCodeComponent from 'vue-qr-generator'
	export default {
		components: {
			'qr-code': VueQRCodeComponent
		},
		created() {
			this.getLoan();
		},
		mounted() { },
		data() {
			return {
				loaded: false,
				loan: {
					id: "",
					hash_id: "",
					interest_amount: "",
					loan_fee: "",
					total_payment: "",
					amount: "",
					term: "",
					initial_payment: "",
					monthly_payment: "",
					start_date: "",
					end_date: "",
					client_name: "",
					phone: "",
					next_payment: "",
					loan_balance: "",
					total_paid: "",
					note: "",
					status: ""
				},
				payment_receipt: {
					hash: "",
					due_date: "",
					paid_date: "",
					paid_by: "",
					created_date: "",
					principal: "",
					interest: "",
					fine: "",
					status: ""
				},
			}
		},
		methods: {
			getLoan(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/loan/get/" + this.$route.params.hash.split("-")[0]).then(data => {
					this.loan = data.body.data

					this.$http.get(this.config.api + "/admin/loan/get_payment_receipt/" + this.$route.params.hash).then(data => {
						this.payment_receipt = data.body.data
						this.loaded = true;
						setTimeout(() => {
							window.print();
						}, 1000)
					})
				})

			},
		}
	}
</script>

<style>
	table {
		page-break-inside:auto;
	}
   tr {
		page-break-inside:avoid;
		page-break-after:auto
	}
   thead {
		display:table-header-group
	}
   tfoot {
		display:table-footer-group
	}

	.no-hover:hover {
		background-color: #FFF !important;
	}
	.center {
		text-align: center;
	}

	body {
		background-color: #FFF !important;
	}
	.print-row-bold {
		font-weight: bold;
	}

	.print-row {
		border: 1px solid black;
		text-align: center;
		padding: 5px;
		font-size: 12px;
	}

	.print-logo {
		height: 100px !important;
		margin: 16px;
	}

	.order-title {
		margin-top: 0;
		margin-bottom: 0;
		font-family: 'Moul';
	}

	.product-thumbnail {
		width: 64px;
		height: 64px;
		margin-right: 13px;
	}
	.print-logn-td {
		font-size: 13px;
		border-top: 1px solid #eee;
		border-bottom: 1px solid #eee;
		padding: 5px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/PrintReceipt.vue